import React, { Fragment } from 'react';
import PropTypes, { object } from 'prop-types';

import {
  Table,
  DateTime,
  TableCell
} from 'components/common/Elements/Elements';

import Massage from '../Massage/Massage';

import classes from './SentimentTable.module.scss';

const TableRow = ({
  company,
  tableConf,
  row,
  mouseEnter,
  onOpenAdditionalModal
}) => {
  return (
    <Table.Row className={classes.row}>
      {tableConf.map(({ title, show, field }, ind) => {
        const cellProps = {
          row: row,
          mouseEnter: mouseEnter,
          ind: ind,
          field: field,
          classes: classes
        };
        return (
          <Fragment key={`${title}-${company._id}}`}>
            {show && field === 'sentimentDate' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.sentimentDate} time />
              </TableCell>
            )}
            {show && field === 'sentiment' && (
              <TableCell cellProps={cellProps} classNameContent={classes.id}>
                {company.sentiment}
              </TableCell>
            )}
            {show && field === 'comments' && (
              <TableCell cellProps={cellProps} classNameContent={classes.id}>
                <Massage
                  title={'Comment'}
                  data={company}
                  onOpenAdditionalModal={onOpenAdditionalModal}
                />
              </TableCell>
            )}
          </Fragment>
        );
      })}
    </Table.Row>
  );
};

TableRow.propTypes = {
  company: PropTypes.object,
  tableConf: PropTypes.arrayOf(object),
  row: PropTypes.string,
  mouseEnter: PropTypes.func,
  onOpenAdditionalModal: PropTypes.func.isRequired
};

export default TableRow;
